import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
export function About() {
  return <section id="quienes-somos" className="bg-brand-primary" data-id="element-16">
      {/* PART A — TEXT */}
      <div className="py-20 md:py-32 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-17">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-18">
          <span className="text-brand-gold text-sm font-bold tracking-widest uppercase mb-4 block" data-id="element-19">
            Quiénes Somos
          </span>
          <h2 className="text-4xl md:text-5xl font-serif text-brand-cream mb-4" data-id="element-20">
            Cabrera Resto Bar
          </h2>
          <p className="text-xl md:text-2xl font-serif italic text-brand-gold mb-10" data-id="element-21">
            "Un pedacito de New York en Bogotá"
          </p>

          <div className="max-w-3xl mx-auto space-y-6 text-brand-cream/80 text-base md:text-lg leading-relaxed" data-id="element-22">
            <p data-id="element-23">
              Inspirados en el Meatpacking District de Nueva York, nos
              destacamos por nuestra decoración que evoca las antiguas fábricas
              de esta exclusiva zona, en donde la madera y el metal hacen de
              este bistró americano un sitio único en su tipo.
            </p>
            <p data-id="element-24">
              Nuestro menú es preparado con materia prima selecta que se
              adquiere principalmente en los mercados locales para poder
              reflejar así los sabores, colores y texturas artesanales que nos
              transportan a tiempos pasados. Cada uno de los platos se prepara
              al momento respetando los tiempos, técnicas y detalles para llevar
              a la mesa una combinación de sabores que cautivan paladares.
            </p>
          </div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16" data-id="element-25">
          {[{
          icon: '🏛️',
          title: 'Inspirados en NY',
          desc: 'Decoración industrial que evoca el Meatpacking District de Nueva York'
        }, {
          icon: '🥩',
          title: 'Ingredientes Selectos',
          desc: 'Materia prima adquirida en mercados locales para garantizar frescura y calidad'
        }, {
          icon: '⏱️',
          title: 'Preparado al Momento',
          desc: 'Cada plato respeta los tiempos, técnicas y detalles de la gastronomía artesanal'
        }].map((card, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: idx * 0.2
        }} className="bg-brand-secondary p-8 rounded-2xl border border-brand-gold/10 hover:border-brand-gold/40 transition-colors text-center" data-id="element-26">
              <div className="text-4xl mb-4" data-id="element-27">{card.icon}</div>
              <h3 className="text-xl font-serif text-brand-cream mb-3" data-id="element-28">
                {card.title}
              </h3>
              <p className="text-brand-cream/60 text-sm leading-relaxed" data-id="element-29">
                {card.desc}
              </p>
            </motion.div>)}
        </div>
      </div>

      {/* PART B — SPLIT VISUAL */}
      <div className="flex flex-col lg:flex-row w-full" data-id="element-30">
        <div className="w-full lg:w-1/2 min-h-[400px] lg:min-h-[600px] relative" data-id="element-31">
          <img src="https://cdn.magicpatterns.com/uploads/5WEL9zc5sTnSbbvpgrUhJo/restaurante_cabrerabar_3.jpg" alt="Interior Cabrera — cabinas rojas, ladrillo y retratos icónicos" className="absolute inset-0 w-full h-full object-cover" data-id="element-32" />
          <div className="absolute inset-0 bg-black/15" data-id="element-33"></div>
        </div>
        <div className="w-full lg:w-1/2 bg-brand-primary p-10 md:p-20 flex flex-col justify-center" data-id="element-34">
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-35">
            <span className="text-brand-gold text-sm font-bold tracking-widest uppercase mb-4 block" data-id="element-36">
              Nuestra Esencia
            </span>
            <h2 className="text-3xl md:text-4xl font-serif text-brand-cream mb-6" data-id="element-37">
              Curaduría en cada detalle
            </h2>
            <p className="text-brand-cream/70 text-base mb-8 leading-relaxed" data-id="element-38">
              Cada rincón de Cabrera fue diseñado para crear una atmósfera
              única. La madera cálida, el metal industrial y la iluminación
              envolvente trasladan a nuestros visitantes a los exclusivos
              barrios de Nueva York, sin salir de Bogotá.
            </p>

            <ul className="space-y-3 mb-10" data-id="element-39">
              {['Música en vivo los fines de semana', 'Menú de temporada renovado constantemente', 'Chef con formación internacional', 'Decoración inspirada en el Meatpacking District', 'Ambiente Pet Friendly en terrazas', 'DJ y eventos especiales cada semana', 'Ingredientes frescos de mercados locales'].map((item, idx) => <li key={idx} className="flex items-start" data-id="element-40">
                  <span className="text-brand-gold mr-3 mt-1" data-id="element-41">•</span>
                  <span className="text-brand-cream/80 text-sm" data-id="element-42">{item}</span>
                </li>)}
            </ul>

            <Link to="/menu" className="inline-block px-8 py-3 rounded-full border-2 border-brand-gold text-brand-gold font-semibold hover:bg-brand-gold hover:text-brand-primary transition-all duration-300" data-id="element-43">
              VER NUESTRO MENÚ
            </Link>
          </motion.div>
        </div>
      </div>

      {/* PART C — QUOTE STRIP */}
      <div className="relative py-24 md:py-32 flex items-center justify-center overflow-hidden" data-id="element-44">
        <div className="absolute inset-0 z-0" data-id="element-45">
          <img src="https://cdn.magicpatterns.com/uploads/5WEL9zc5sTnSbbvpgrUhJo/restaurante_cabrerabar_3.jpg" alt="Interior Cabrera" className="w-full h-full object-cover" data-id="element-46" />
          <div className="absolute inset-0 bg-black/75" data-id="element-47"></div>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="relative z-10 text-center px-4 max-w-4xl mx-auto" data-id="element-48">
          <div className="w-16 h-px bg-brand-gold mx-auto mb-8" data-id="element-49"></div>
          <h3 className="text-2xl md:text-4xl font-serif italic text-brand-cream leading-relaxed mb-8" data-id="element-50">
            "La madera y el metal hacen de este bistró americano un sitio único
            en su tipo."
          </h3>
          <div className="w-16 h-px bg-brand-gold mx-auto mb-6" data-id="element-51"></div>
          <p className="text-brand-gold text-sm font-medium tracking-wider uppercase" data-id="element-52">
            — Cabrera Resto Bar, Bogotá
          </p>
        </motion.div>
      </div>
    </section>;
}